import "./bootstrap";
import "./jquery";
import "./axios";
import "./swiper";
import "./typed";
import "./accounting";
import "./nouislider";
import "./lozad";
import "./leaflet";
import "./wnumb";
import "./lightbox2";
// import "./aos";
import "./plyr";
import "./tom-select";
import "./utm";
if (import.meta.env.PROD) {
    import('./ekonsilio').then(({ initEkonsilioChat, onUserInteract, observerUserChat }) => {
        observerUserChat();
    });
}
if (import.meta.env.PROD) {
import("./lenis");
}
import "./import-custom-modules";
import "./screensaver";
import "./myscripts"; // myscripts sempre alla fine
